"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupByArray = groupByArray;
exports.groupByArrayAsync = groupByArrayAsync;
exports.flipSet = flipSet;
function groupByArray(array, keyProvider) {
    const result = new Map();
    array.forEach((item) => {
        const key = keyProvider(item);
        if (!result.has(key)) {
            result.set(key, [item]);
        }
        else {
            result.get(key)?.push(item);
        }
    });
    return result;
}
async function groupByArrayAsync(array, keyProvider) {
    const result = new Map();
    for (const item of array) {
        const key = await keyProvider(item);
        if (!result.has(key)) {
            result.set(key, [item]);
        }
        else {
            result.get(key)?.push(item);
        }
    }
    return result;
}
function flipSet(set, item) {
    if (set.has(item)) {
        set.delete(item);
    }
    else {
        set.add(item);
    }
    return set;
}
//# sourceMappingURL=common.js.map